import React from "react";
import { object } from "prop-types";
import { useParams } from "react-router-dom";
import { PageSpinner } from "../components/generic/spinners";

export const Login = ({ auth }) => {
  const { pdClientType } = useParams();
  if (pdClientType) {
    auth.setPdClientType(pdClientType);
  }
  auth.login();
  return <PageSpinner text={"Redirecting to Login screen..."} />;
};

Login.propTypes = {
  auth: object
};
